import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fdatetime } from "@/lib/api";
import { DataTable } from "@/components/common";
import Modal from "@/components/Modal";

export function AdminGlobal() {
  const [info, setInfo] = useState(null);
  const [counters, setCounters] = useState([]);
  const load = () => { api.get("/admin/integrations").then((r) => setInfo(r.data)); api.get("/admin/counters").then((r) => setCounters(r.data)); };
  useEffect(() => { load(); }, []);
  const bump = async (c) => {
    const v = window.prompt(`Nouvelle valeur du compteur ${c.id} (minimum ${c.n})`, c.n);
    if (v === null) return;
    try { await api.put(`/admin/counters/${c.id}`, { n: Number(v) }); toast.success("Compteur mis à jour"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const ok = (b) => <span className={b ? "font-bold text-[#2E7D5B]" : "font-bold text-[#B03A3A]"}>{b ? "Configuré" : "Non configuré"}</span>;
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="card space-y-3 p-6 text-sm" data-testid="admin-integrations">
        <h3 className="font-bold">Intégrations</h3>
        <p>Microsoft 365 (Entra ID) : {info && ok(info.m365)} {info?.sso_only && "· connexion SSO uniquement"}</p>
        <p className="text-xs text-[#6B6B80]">Locataire : <span className="mono">{info?.tenant}</span><br />Redirection : <span className="mono">{info?.redirect_uri}</span></p>
        <p>OCR Gemini : {info && ok(info.ocr_gemini)}</p>
        <p className="rounded-md bg-[#F4F4F8] p-3 text-xs">Groupe super admin : <span className="mono">{info?.superadmin_group}</span>.</p>
        <Link to="/parametres" className="btn-primary inline-flex" data-testid="admin-settings-link">Seuils, plan comptable et Microsoft 365</Link>
      </div>
      <DataTable rows={counters} title="Numérotation" testid="admin-counters-table" onRowClick={bump}
        columns={[{ key: "id", label: "Compteur", render: (r) => <span className="mono text-xs">{r.id}</span> }, { key: "n", label: "Dernier numéro", type: "number" }]} />
    </div>
  );
}

export function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [cur, setCur] = useState(null);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data)); }, []);
  return (
    <>
      <p className="mb-3 text-sm text-[#6B6B80]">Journal inaltérable : aucune ligne ne peut être modifiée ni supprimée. Cliquez sur une ligne pour voir les valeurs avant / après.</p>
      <DataTable rows={rows} testid="admin-audit-table" title="Journal d'audit" pageSize={25} onRowClick={setCur} columns={[
        { key: "at", label: "Date", value: (r) => fdatetime(r.at) }, { key: "user", label: "Qui" }, { key: "role", label: "Rôle" }, { key: "ip", label: "Adresse IP" },
        { key: "action", label: "Action" }, { key: "entity", label: "Élément" }, { key: "details", label: "Détails" }]} />
      <Modal open={!!cur} onClose={() => setCur(null)} title={cur?.action || ""} wide testid="admin-audit-detail">
        <div className="grid gap-4 md:grid-cols-2">{["before", "after"].map((k) => <div key={k}><h4 className="mb-1 text-sm font-bold">{k === "before" ? "Avant" : "Après"}</h4>
          <pre className="max-h-96 overflow-auto rounded-md bg-[#F4F4F8] p-3 text-xs" data-testid={`admin-audit-${k}`}>{cur?.[k] ? JSON.stringify(cur[k], null, 2) : "—"}</pre></div>)}</div>
      </Modal>
    </>
  );
}
